export default __webpack_public_path__ + "static/media/hyd-travel.1696a200.jpg";